import { motion } from 'framer-motion';
import styled from 'styled-components';
import { setVh } from 'utils/styles/mixins';
import { colors, layout } from 'utils/styles/theme';

import BgImage from 'assets/img/overlay-background.png';
import BgImageMob from 'assets/img/overlay-background-mobile.png';
import { mediaDesktopLarge, mediaMobile } from 'utils/styles/responsive';
import { ButtonWrapper } from 'components/ButtonCta/ButtonCta.styles';

export const Wrapper = styled(motion.div)`
    width: 100%;
    height: 100svh;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: ${layout.zIndex.modals + 1};
    position: fixed;
    // background-image: url(${BgImage});
    // background-color: rgba(0,0,0,0.2);    
    // background-position: 50% 50%;
    // background-size: cover;    
    display: flex;
    justify-content: center;
    align-items: center;

    // ${mediaMobile(`
    //     width: 80vw;       
    // `)}

`;

export const CloseWrapper = styled(motion.div)`
    width: 50rem;
    height: 50rem;
    overflow: hidden;
    position: fixed;
    top: 20rem;
    right: 20rem;
    cursor: pointer;

    ${mediaMobile(`
        width: 30rem;
        height: 30rem;
    `)}
    
`;

export const Content = styled(motion.div)`
    width: 95vw;
    height: 80vh;
    transform: translateY(10px);
    position: relative;
    z-index: 10;
    backdrop-filter: blur(30px);
    opacity: 0;
    will-change: opacity, transform;
    padding: 100rem 50rem;
    border-radius: 30px;
    border: none;
    background: linear-gradient(to right, 
                rgba(255, 255, 255, 0) 0%, 
                rgba(255, 255, 255, 0.08) 50%, 
                rgba(255, 255, 255, 0.02) 100%);
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: center;

    
    // @keyframes fadeIn {
    //     from {
    //         opacity: 0;
    //         transform: translateY(20px) scale(1.5);
    //     }
    //     to {
    //         opacity: 1;
    //         transform: translateY(0px) scale(1.5);
    //     }
    // }

    &.fadeIn {
        transition: all 0.7s 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
        opacity: 1;
        transform: translateY(0px);
    }

    &.fadeOut {
        transition: all 0.2s 0s ease-out;
        opacity: 0;
        transform: translateY(10px);
    }

    ${mediaMobile(`
        // width: 90vw;
        height: 60vh;
        padding: 60rem 20rem;
        transform: translateY(-3vh) scale(1);
        &.fadeIn {
            transform: translateY(-5vh) scale(1);
        }

        &.fadeOut {
            transform: translateY(-3vh) scale(1);
        }
    `)}
`;

export const ContentHeader = styled(motion.div)`
    width: 100%;
    color: ${colors.white};
    font-family: FontLight;
    font-size: 36rem;
    letter-spacing: 2.88rem;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16rem;
    
    ${mediaMobile(`
        font-size: 16rem;
    `)}

    > span {
        width: auto;
        text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    }
`;

export const ContentTitle = styled(motion.h4)`
    width: 100%;
    color: ${colors.white};
    font-family: FontRegular;
    font-size: 60rem;
    line-height: 1.1;
    letter-spacing: 2.88rem;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 16rem;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);

    span {
        font-size: 30rem;
    }
    
    ${mediaMobile(`
        margin-top: 16rem;
        margin-bottom: 16rem;
        letter-spacing: 1rem;
        font-size: 20rem;

        span {
            font-size: 14rem;
        }
    `)}
`;

export const ContentSubtitle = styled(motion.div)`
    width: 100%;
    color: ${colors.white};
    font-family: FontRegular;
    margin: 17rem auto 80rem auto;
    display: flex;
    width: 100%;
    align-items: center;
    gap: 20rem;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);

    ${mediaMobile(`
        margin: 17rem auto 36rem auto;
    `)}
`;
export const ContentSubtitleLeft = styled(motion.div)`
    font-family: FontRegular;
    font-size: 30rem;
    letter-spacing: 2.88rem;
    text-transform: uppercase;
    text-align: left;
    white-space: nowrap;    
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    
    ${mediaMobile(`
        font-size: 10rem;
    `)}
`;
export const ContentSubtitleRight = styled(motion.div)`
    width: 100%;
    color: ${colors.white};
    font-family: FontLight;
    font-size: 16rem;
    text-align: left;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    
    ${mediaMobile(`
        font-size: 10rem;
    `)}
`;

export const ContentSubtitleDivide = styled.div`
    width: 1px;
    height: 62rem;
    background: ${colors.white};
    margin: 0 20rem;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);

     ${mediaMobile(`
        margin: 0 5rem;
    `)}
`;

export const CtaWrapper = styled(motion.div)`
    width: 100%;
    // height: 60rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10rem;
    position: relative;
    margin-top: 36rem;

    ${ButtonWrapper} {        
        width: 300rem;
        position: relative;
        z-index: 1;
        // position: absolute;
        // left: 50%;
        // transform: translateX(-50%);
        ${mediaMobile(`        
            width: 200rem;
        `)}
    }

`;
